fx.ns("shared.stage", class BaseCalendarCell extends fx.Component {
    constructor(data, day, model) {
        super(data);
        this._day = day ? day : (new Date()).getDate();
        this._model = model;
    }

    get day() {
        return this._day;
    }

    get model()
    {
        return this._model;
    }

    get creation()
    {
        return this.model ? this.model.creation : null;
    }

    /**
     * Component initialization.
     */
    create() {
        super.create();

        this.dayComponent = new fx.components.Text({ text: this.day, className: "day" });
        this.dayComponent.css({ fontSize: 5 * this.creation.extraScale + "px" });

        this.addChild(this.dayComponent, { top: "center", right: "center" });
    }

});